import classNames from "classnames"
import React, { useContext } from "react"
import { useQuery } from "react-query"
import { BoaterInvoicesContext } from "src/main/Account/Invoices"

import ReloadableWidget from "src/components/ReloadableWidget"

import { queryUnsettledInvoiceTotalsByCurrency } from "src/api/Account/Invoices"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const InvoiceTotals = () => {
  const { translations } = useContext(BoaterInvoicesContext)

  const {
    data: totalsByCurrency,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["unsettledInvoiceTotalsByCurrency"],
    queryFn: () => queryUnsettledInvoiceTotalsByCurrency(),
    placeholderData: [],
    retry: false,
  })

  const hasCurrentTotalData =
    totalsByCurrency?.length > 0
      ? totalsByCurrency
          .map((currencyTotalSet) => currencyTotalSet.current)
          .reduce((a, b) => a + b) > 0
      : false
  const hasUpcomingTotalData =
    totalsByCurrency?.length > 0
      ? totalsByCurrency
          .map((currencyTotalSet) => currencyTotalSet.upcoming)
          .reduce((a, b) => a + b) > 0
      : false

  const renderTotal = (totalType, currencyTotalSet) => {
    const { currency, current, upcoming } = currencyTotalSet
    const skipCurrencyPrefix = totalsByCurrency.length === 1
    const total = totalType === "current" ? current : upcoming

    return (
      <div key={`${totalType}-${currency}`}>
        {total !== 0 ? (
          <div className="mb-2 flex items-center gap-3">
            {skipCurrencyPrefix ? null : (
              <span className="text-muted text-sm font-semibold">
                {currency}
              </span>
            )}
            <div
              className={classNames("text-2xl font-bold", {
                "text-red-600": totalType === "current",
              })}
            >
              {formatCurrencyFromMinorUnits({ amount: total, currency })}
            </div>
          </div>
        ) : null}
      </div>
    )
  }

  const renderNone = () => (
    <span className="text-muted text-sm font-semibold">
      {translations.none}
    </span>
  )

  return (
    <div className="flex flex-col gap-6 text-base">
      <ReloadableWidget isLoading={isFetching} isError={isError}>
        <div className="card flex grid grid-cols-2 gap-4 shadow-md sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-1">
          <div>
            <div className="mb-2 font-semibold">{translations.current}</div>
            {hasCurrentTotalData
              ? totalsByCurrency.map((currencyTotalSet) =>
                  renderTotal("current", currencyTotalSet)
                )
              : renderNone()}
          </div>
          <div>
            <div className="mb-2 font-semibold">{translations.upcoming}</div>
            {hasUpcomingTotalData
              ? totalsByCurrency.map((currencyTotalSet) =>
                  renderTotal("upcoming", currencyTotalSet)
                )
              : renderNone()}
          </div>
        </div>
      </ReloadableWidget>
    </div>
  )
}

export default InvoiceTotals
